const popoutLoadedCallbacks: PopoutLoadedCallback[] = [];
export type PopoutLoadedCallback = (tabId: string) => Promise<void>;

export const popoutLoaded = (tabId: string): void => {
    for (const cb of popoutLoadedCallbacks) {
        cb(tabId);
    }
};

export const registerPopoutLoadedCallback = (cb: PopoutLoadedCallback): void => {
    popoutLoadedCallbacks.push(cb);
};
